import { strVal } from "@paroi/data-formatters-lib";
import { fetchQuery } from "../shared/http-client";

export async function fetchDeveloperTokenAPI(referenceId: number): Promise<string | undefined> {
  const res = await fetchQuery(`references/${referenceId}/api-key`);
  const data = res.data;
  if (
    !data ||
    typeof data !== "object" ||
    data === null ||
    Array.isArray(data) ||
    !("api_key" in data)
  )
    return;
  try {
    return strVal(data.api_key);
  } catch (error) {
    console.error("Error fetching developer token:", error);
    return;
  }
}

export async function updateDeveloperTokenAPI(referenceId: number): Promise<string | undefined> {
  const res = await fetchQuery(`references/${referenceId}/regenerate-api-key`, {
    method: "PUT",
    body: JSON.stringify({}),
  });
  if (!res || !res.data) return;
  const data = res.data;
  if (
    !data ||
    typeof data !== "object" ||
    data === null ||
    Array.isArray(data) ||
    !("api_key" in data)
  )
    return;
  try {
    return strVal(data.api_key);
  } catch (error) {
    console.error("Error updating developer token:", error);
    return;
  }
}
